import {
  PUT_INPUT_DATA,
  GET_REPORT,
  GET_ALL_FILES,
  GET_INPUT_FILE,
} from "./apiEndpoints";

export const putInputData = async (restaurantId, frontendPath, file) => {
  const formData = new FormData();
  formData.append("inputFile", file);

  const hasAdmin = frontendPath.includes("admin");
  const token = localStorage.getItem("authToken");

  const response = await fetch(PUT_INPUT_DATA(restaurantId), {
    method: "POST",
    headers: {
      "Admin-Request": hasAdmin,
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch report: ${response.statusText}`);
  }

  const contentType = response.headers.get("Content-Type");
  if (!contentType || !contentType.includes("application/pdf")) {
    throw new Error("Expected PDF file, but received: " + contentType);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "restaurant_report.pdf";
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
};

export const getReport = async (frontendPath, filename) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(GET_REPORT(filename), {
      headers: {
        "Admin-Request": frontendPath.includes("admin"),
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch report.");
    }
    return await response;
  } catch (error) {
    console.error("Error in fetching report: ", error);
    throw error;
  }
};

export const getInputFile = async (frontendPath, filename) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(GET_INPUT_FILE(filename), {
      headers: {
        "Admin-Request": frontendPath.includes("admin"),
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch report.");
    }
    return await response;
  } catch (error) {
    console.error("Error in fetching report: ", error);
    throw error;
  }
};

export const getAllFiles = async (restaurantId, frontendPath) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(GET_ALL_FILES(restaurantId), {
      headers: {
        "Admin-Request": frontendPath.includes("admin"),
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch all reports.");
    }
    return await response;
  } catch (error) {
    console.error("Error in fetching all reports: ", error);
    throw error;
  }
};
